export const cutString = (str: string, length = 10) => {
  if (str.length > length) {
    return `${str.slice(0, length)}...`;
  }
  return str;
};

export const onlyDigits = (str: string) => str.replace(/\D/g, '');
